export const PARENT_SITE_ORIGIN = (process.env.REACT_APP_PARENT_SITE_ORIGIN || '').split(',').filter((o) => !!o);
